import axios from './axios-instance'

export default {
  all ({ q = '', page = 1, limit = 20, admin = false }) {
    return axios.get(`v1/training_library?limit=${limit}&page=${page}&q=${q}&admin=${admin}`)
  },
  createOrUpdate (payload) {
    return axios.post(`v1/training_library`, payload)
  },
  destroy (id) {
    return axios.delete(`v1/training_library/${id}`)
  }
}
